import { render } from "./IconDownload.vue?vue&type=template&id=08eca237"
import script from "./IconDownload.vue?vue&type=script&lang=ts"
export * from "./IconDownload.vue?vue&type=script&lang=ts"
script.render = render

export default script